export const fixToTwo = (n: number): number => {
  return parseFloat(n?.toFixed(2));
};

export const formatWithCommas = (n: number, locale: string = "en-US"): string =>
  n.toLocaleString(locale);

export function formatPercent(value: number, total?: number): string {
  if (total === undefined) {
    return `${value.toFixed(2)}%`;
  }
  if (total === 0) return "0%";
  return `${Math.round((value / total) * 100)}%`;
}

export function NumberFormatter({ value }: { value: number }) {
  return <>{formatWithCommas(fixToTwo(+value))}</>;
}
